import env from '@travel/env';

export default function redirectToSSO() {
  window.location.href = env('UNIVERSAL_SSO_LOGIN_URL') || '';
}
